export default __webpack_public_path__ + "static/media/gray_dummy_image.81c89969.svg";